 <template>
  <div>
    <div class="form-group">
      <label>Template</label>
      <select class="form-control" v-model="advanced_visual.template_id">
        <option :value="1">Standard</option>
        <option :value="3">Two Column</option>
        <option :value="4">Two Column w/ Header</option>
        <option :value="2">Blank</option>
      </select>
    </div>
    <div class="form-group">
      <label>Preset Resolutions</label>
      <select
        class="form-control"
        v-model="preview_settings.preset_resolution"
        @change="changePresetResolution"
      >
        <option value="1280x720">1280x720</option>
        <option value="1366x768">1366x768</option>
        <option value="1440x900">1920x1080</option>
        <option value="1536x864">1536x864</option>
        <option value="1600x900">1600x900</option>
        <option value="1920x1080">1920x1080</option>
        <option value="2560x1440">2560x1440</option>
      </select>
    </div>
    Show Unavailable Sections?
    <input
      type="checkbox"
      v-model="preview_settings.show_unavailable_sections"
    />
    <br /><br />
    <div class="form-group">
      <label>Name</label>
      <input type="text" class="form-control" v-model="advanced_visual.name" />
    </div>
    <br /><br />
    Background Color:
    <color-picker
      v-model="advanced_visual.background_color"
      @input="changeBackgroundColor"
    ></color-picker>
    <br /><br />
    <div class="form-group">
      <button type="button" class="btn btn-hub-primary" @click="submit()">
        Save
      </button>
      <button type="button" class="btn btn-secondary" @click="reset()">
        Reset
      </button>
      <router-link
        :to="{ name: 'AlertSummary', params: { alert_id: alert_id } }"
        class="btn btn-secondary"
        v-if="!in_modal"
        >Cancel</router-link
      >
    </div>
    <div
      :style="
        'background-color:' +
        advanced_visual.background_color +
        ';height:' +
        preview_settings.height +
        'px;width:' +
        preview_settings.width +
        'px;font-size:3vw;'
      "
    >
      <div
        class="row h-100"
        v-if="advanced_visual.template_id === 1"
        :style="'background-color:' + advanced_visual.background_color"
      >
        <div class="col-12">
          <div class="row h-25 text-left">
            <div class="col-6 visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content2"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
            <div class="col-6 text-right visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content3"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
          </div>
          <div class="row h-50">
            <div
              :class="{
                'col-1': true,
                'visual-section': true,
                'visual-unavailable-section':
                  preview_settings.show_unavailable_sections,
              }"
            ></div>
            <div class="col-10 text-center visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content1"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
            <div
              :class="{
                'col-1': true,
                'visual-section': true,
                'visual-unavailable-section':
                  preview_settings.show_unavailable_sections,
              }"
            ></div>
          </div>
          <div class="row h-25">
            <div class="col-6 text-left visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content4"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
            <div class="col-6 text-right visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content5"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row h-100"
        v-if="advanced_visual.template_id === 2"
        :style="'background-color:' + advanced_visual.background_color"
      >
        <div class="col-12">
          <div class="row h-100">
            <div class="col-12 text-center visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content1"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row h-100"
        v-if="advanced_visual.template_id === 4"
        :style="'background-color:' + advanced_visual.background_color"
      >
        <div class="col-12">
          <div class="row h-25 text-left">
            <div class="col-12 visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content3"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
          </div>
          <div class="row h-75">
            <div class="col-6 text-center visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content1"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
            <div class="col-6 text-center visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content2"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row h-100"
        v-if="advanced_visual.template_id === 3"
        :style="'background-color:' + advanced_visual.background_color"
      >
        <div class="col-12">
          <div class="row h-100">
            <div class="col-6 text-center visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content1"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
            <div class="col-6 text-center visual-section">
              <editor
                inline
                v-model="advanced_visual.resolutions[0].content2"
                :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init"
                class="custom-editor"
              >
              </editor>
            </div>
          </div>
        </div>
      </div>
    </div>
    <GuidedPrompt
      :passed_state="guided_states.ASK_CREATE_ANOTHER_VISUAL"
      :creation_object="this.advanced_visual"
    ></GuidedPrompt>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'
import Editor from '@tinymce/tinymce-vue'
import { mapGetters } from 'vuex'
import GuidedPrompt from '../../../components/Alert/GuidedPrompt'

export default {
  props: {
    alert_id: { type: [Number, String], required: true },
    in_modal: { type: Boolean, default: false }
  },
  components: {
    'color-picker': Chrome,
    editor: Editor,
    GuidedPrompt
  },
  data: function () {
    return {
      preview_settings: {
        preset_resolution: '1280x720',
        width: 1280,
        height: 720,
        show_unavailable_sections: true
      },
      tinyMCEGlobalConfig: {
        api_key: '5i8aeub8k5so19rj2bdfd2qgu5vjsp2gx063fxi3tzs4jw27'
      },
      tinyMCETextConfig: {
        init: {
          menubar: false,
          fontsize_formats: '1vw 2vw 3vw 4vw 5vw 6vw',
          plugins: [
            'advlist lists link image charmap preview anchor',
            'searchreplace emoticons media paste',
            'template'
          ],
          toolbar_mode: 'wrap',
          toolbar: [
            'undo redo | bold italic underline backcolor forecolor | fontsizeselect',
            'alignleft aligncenter alignright alignjustify | link image media emoticons | fontselect',
            'bullist numlist outdent indent | strikethrough subscript superscript | removeformat'
          ],
          automatic_uploads: true,
          images_upload_url:
            location.origin + '/api/advanced_visual_image_upload',
          images_reuse_filename: true,
          file_picker_types: 'image',
          file_picker_callback: function (cb, value, meta) {
            var input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', 'image/*')

            input.onchange = function () {
              var file = this.files[0]

              var reader = new FileReader()
              reader.onload = function () {
                var id = 'blobid' + new Date().getTime()
                var blobCache = tinymce.activeEditor.editorUpload.blobCache
                var base64 = reader.result.split(',')[1]
                var blobInfo = blobCache.create(id, file, base64)
                blobCache.add(blobInfo)

                cb(blobInfo.blobUri(), { title: file.name })
              }
              reader.readAsDataURL(file)
            }

            input.click()
          }
        }
      },
      advanced_visual: {
        advanced_visual_id: 0,
        template_id: 1,
        alert_id: this.alert_id,
        name: '',
        background_color: '#FFFFFF',
        resolutions: [
          {
            resolution: '1280x720',
            content1: 'A Test Alert',
            content2: '',
            content3: '',
            content4: '',
            content5: '',
            content6: ''
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      scoped_site_id: 'scopedSiteId',
      guided_states: 'allGuidedStates'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
  },
  methods: {
    changeBackgroundColor (data) {
      this.advanced_visual.background_color = data.hex
    },
    changePresetResolution () {
      this.preview_settings.width = this.preview_settings.preset_resolution.split(
        'x'
      )[0]
      this.preview_settings.height = this.preview_settings.preset_resolution.split(
        'x'
      )[1]
    },
    submit () {
      if (!this.in_modal) {
        $('#guidedPrompt').modal('show')
      } else {
        this.$store.dispatch('addEditAdvancedVisual', { advanced_visual: this.advanced_visual, next: null })
        $('#genericModal').modal('hide')
      }
    },
    reset () {
      this.advanced_visual = {
        advanced_visual_id: 0,
        template_id: 1,
        alert_id: this.alert_id,
        name: '',
        background_color: '#FFFFFF',
        resolutions: [
          {
            resolution: '1280x720',
            content1: 'An Advanced Visual Alert',
            content2: '',
            content3: '',
            content4: '',
            content5: '',
            content6: ''
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.custom-editor {
  height: 100%;
}
.visual-defaults {
  font-size: 1vw;
}
.visual-section {
  border: 1px dashed black;
}
.visual-unavailable-section {
  background: repeating-linear-gradient(
    45deg,
    #d61c1c,
    #d61c1c 10px,
    #ffffff 15px,
    #ffffff 30px
  );
}
</style>
